<template>
<b-modal  id="orders-import-modal" title="Import Order Shipping Info" hide-footer @hidden="modalClosed">

   <template #modal-header="{ close }">

      <h3>Shipping Data Update</h3>

      <!-- Emulate built in modal header close button action -->
      <b-button size="sm" variant="outline-danger" @click="close()">
        Close Widget
      </b-button>
    </template>

  <div v-if="storeId">
    <!-- <ul class="uploadStatus" v-if="files.length > 0">
      <li v-for="(file, index) in files" :key="index">
          <h5>
            {{file.name}}  
          </h5>
          <div>
            Error: {{file.error}}
          </div> 
          <div>
            Success: {{file.success}}
          </div>
        </li>
    </ul> 
    
     <file-upload input-id="file1" ref="upload" v-model="files" :post-action="`${API_URL}imports/update-order-from-excel`" put-action="" @input-file="inputFile" @input-filter="inputFilter" class="uploadExplorer" :data="{storeId: storeId, shippingService: selected}" :headers="{'x-access-token': token}" :drop="true">
      Upload file
    </file-upload>
    <b-alert variant="success" show v-show="$refs.upload && $refs.upload.uploaded">
        Import successfully done. Wait for sometime to see the effect.
        {{ $refs.upload && $refs.upload.uploaded }}
    </b-alert> -->


    <b-form-group label="Select Shipping Service" v-slot="{ ariaDescribedby }" >
      <b-form-radio-group
        id="radio-group-1"
        v-model="dropzoneOptions.params.shippingService"
        :options="options"
        :aria-describedby="ariaDescribedby"
        name="radio-options"
        buttons
        button-variant="primary"
      ></b-form-radio-group>
    </b-form-group>

    <p>"{{ dropzoneOptions.params.shippingService }}" is the selected courier service</p>

    <vue-dropzone ref="myVueDropzone" id="dropzone" v-on:vdropzone-success="vDropZoneSuccess" :options="dropzoneOptions" class="m-b-30" v-on:vdropzone-error="fromSheetUpdateFailed"></vue-dropzone>

    <b-alert show variant="danger" v-if="uploadError">{{ uploadError }}</b-alert>

    
    <b-button size="lg" variant="dark"  block v-show="!$refs.upload || !$refs.upload.active" @click.prevent="onFormSubmit" type="button">UPDATE SHIPPING DATA</b-button>
    

    
    
    <!-- <div class="clearfix" v-if="selected">
      <button class="btn btn-primary pull-right" v-show="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true" type="button">Upload File</button>
      <button class="btn btn-danger pull-right" v-show="$refs.upload && $refs.upload.active" @click.prevent="$refs.upload.active = false" type="button">Stop Upload</button>
    </div> -->
  </div>
  <div v-else>
    Didn't find store ID. Please refresh and try
  </div>
</b-modal>
</template>

<script>
import EventBus from '../../../EventBus'
import VueUploadComponent from 'vue-upload-component';
import { API_URL } from "../../../services/constants";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  data() {
    return {
      uploadError: '',
      storeId: null,
      files: [],
      token: JSON.parse(localStorage.getItem("user")).accessToken,
      API_URL: API_URL,
      selected: '',
      options: [
          // { text: 'CJ Dropshipping', value: 'cj' },
          { text: 'DHL Ecommerce', value: 'dhl-ecommerce', selected: true },
          { text: 'DHL Express', value: 'dhl-express', selected: false },
        ],
      dropzoneOptions: {
          url: `${API_URL}imports/update-shipping-data-from-excel`,
          thumbnailWidth: 100,
          maxFilesize: 100,
          headers: {"x-access-token": JSON.parse(localStorage.getItem("user")).accessToken},
          params: {storeId: null, shippingService: 'dhl-ecommerce'},
          autoProcessQueue: false,
          dictDefaultMessage: 'Explore Shipping Data Excel from your system.',
          addRemoveLinks: true
       }
    }
  },
  watch: {
    // whenever question changes, this function will run
    'dropzoneOptions.params.shippingService': function (newValue, oldValue) {
        this.dropzoneOptions.params.shippingService = newValue;
    }
  },
  components: {
    VueUploadComponent,
    vueDropzone: vue2Dropzone
  },

  methods: {
    modalClosed(){
       this.files = [];
       this.$refs.upload.uploaded = false;
    },
    vDropZoneSuccess(file, response){
       console.log('Vue dropzone response', response)
    },
    onFormSubmit() {
       this.$refs.myVueDropzone.processQueue()
    },
    fromSheetUpdateFailed(file,message,xhr){
      let response = xhr.response;
      let parse = JSON.parse(response, (key, value)=>{
        return value;
      });

      //$(file.previewElement).find(".dz-error-message span").text( parse.message )
      let currentFile = file.previewElement;
      let msgElement = currentFile.querySelector('.dz-error-message span');
      msgElement.innerHTML = parse.message
      this.uploadError = parse.message;

      setTimeout(() => this.uploadError = '', 5000)
    }
  },
  mounted() {
    EventBus.$on("initiated-import-order-from-excel", ({
      storeId
    }) => {
      this.storeId = storeId;
      this.dropzoneOptions.params.storeId = storeId;
    })
  },
  beforeDestroy() {
    EventBus.$off("initiated-import-order-from-excel")
  }
}
</script>

<style lang="scss" scoped>
.uploadExplorer {
  display: block;
  border: 1px dashed rgb(79, 155, 255);
  background-color: rgb(227, 239, 253);
  color: rgb(41, 111, 202);
  padding: 30px;
  margin-bottom: 10px;
  cursor: pointer;
}

.uploadStatus {
  list-style-type: none;
  padding-left: 0;
  padding: 20px;
  border: 1px solid rgb(207, 207, 207);
  background-color: rgb(233, 233, 233);
}
</style>
